module.exports = __webpack_public_path__ + "img/grille_daeration.2005c1b.svg";